export default "__VITE_ASSET__D973X6c1__"